module.exports = __webpack_public_path__ + "media/application/images/ui/compare-icon-close-e6c4ab66f8a33870ae96cd18e9d80e29.png";